/* eslint-disable react-hooks/exhaustive-deps */
import Page from 'component/Page';
import { useCallback, useEffect, useMemo, useState } from 'react';
import { Button, Tab, Table, Tabs } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import { ACCOUNT_ROLE_ADMIN } from 'util/permission';
import { selectCurrentUser } from 'redux/user/user.selector';
import string from 'util/string';
import { getParams, GUIDChecker, nNU, showToast } from 'util/utils';
import PurchaseAppId from './PurchaseAppId';
import PurchaseSecretChannel from './PurchaseSecretChannel';
import './PurchaseDetail.scss'

const PURCHASE_MONTHLY_TABS = {
    APPID: 'appid',
    CHANNEL: 'channel',
};

const PurchaseMonthlyDetailTabs = {
    appid: {
        title: string.APP_PC_TAB_APPID_TITLE,
        component: PurchaseAppId,
    },
    channel: {
        title: string.APP_PC_TAB_CHANNEL_TITLE,
        component: PurchaseSecretChannel,
    },
};

const PurchaseMonthly = () => {
    //-------------------------------HOOKS-------------------------------------------------------------
    const params = getParams();
    const [ currentTab, setCurrentTab ] = useState(
        params?.tab || PURCHASE_MONTHLY_TABS.APPID,
        // params?.tab || SERVICE_CODE_DETAIL_TABS.APPID,
    );

    const currentUser = useSelector(selectCurrentUser);
    const isAdmin = useMemo(
        () => currentUser.accountRole === ACCOUNT_ROLE_ADMIN,
        [ currentUser.accountRole ]
    );
    const isMonitorOnly = useMemo(
        () => currentUser.isMonitorOnly === 1,
        [ currentUser.isMonitorOnly ]
    );

    // const serviceCodeId = data.serviceCodeId || params?.serviceCodeId || params?.id;
    // const [ selectedCode, setSelectedCode ] = useState(serviceCodeId);


    //------------------------------FUNCTIONS----------------------------------------------------------
    if (isAdmin) {
        if (PurchaseMonthlyDetailTabs.appid) {
            delete PurchaseMonthlyDetailTabs.appid;
        }
        if (PurchaseMonthlyDetailTabs.channel) {
            delete PurchaseMonthlyDetailTabs.channel;
        }
    } else {
        if (!PurchaseMonthlyDetailTabs.appid) {
            PurchaseMonthlyDetailTabs.appid = {
                title: string.APP_SC_TAB_APPID_TITLE,
                component: PurchaseAppId,
            };
        }
        if (!PurchaseMonthlyDetailTabs.channel) {
            PurchaseMonthlyDetailTabs.channel = {
                title: string.APP_SC_TAB_CHANNEL_TITLE,
                component: PurchaseSecretChannel,
            };
        }
    }

    //-------------------------------RETURN------------------------------------------------------------
    return (
        <>
            <Page
                className="screen-service-code-detail"
                title={''}
                body={
                    <>
                        {/* <ServiceCodeUsage /> */}
                        <Tabs activeKey={currentTab} onSelect={(t) => setCurrentTab(t)}>
                            {Object.keys(PurchaseMonthlyDetailTabs).map((t, index) => {
                                let tab = PurchaseMonthlyDetailTabs[ t ];
                                let TabComponent = tab.component;
                                if (!TabComponent) {
                                    return null;
                                }
                                return (
                                    <Tab key={index} eventKey={t} title={tab.title}>
                                        {currentTab === t && (
                                            <TabComponent />
                                        )}
                                    </Tab>
                                );
                            })}
                        </Tabs>
                    </>
                }
            />
        </>
    );
};

export default PurchaseMonthly;